import React from 'react';
import { styled } from '@material-ui/core/styles';

import Controls from './components/Controls/Controls';
import LocalVideoPreview from './components/LocalVideoPreview/LocalVideoPreview';
import MenuBar from './components/MenuBar/MenuBar';
import ReconnectingNotification from './components/ReconnectingNotification/ReconnectingNotification';
import Room from './components/Room/Room';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import useHeight from './hooks/useHeight/useHeight';
import useRoomState from './hooks/useRoomState/useRoomState';
import DialInDetails from './components/DialInDetails/DialInDetails';
const Container = styled('div')({
  display: 'grid',
  gridTemplateRows: 'auto 1fr',
});

const Main = styled('main')({
  overflow: 'hidden',
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    din: {
      
      zIndex:10,
      // position: "absolute", 
      display:"flex",
      flexDirection:"row",
      background:'black',
      width: '100%',
      // opacity:"50%",
      // left: '0px', top: '0px', height: '100%', width: '100%',
           
      '&[disabled]': {
        color: 'rgba(225, 225, 225, 0.8)',
        backgroundColor: 'rgba(175, 175, 175, 0.6);',
      },
    },
    dinphones:{
      padding: theme.spacing(2),
      minWidth:"300px",
    }
  })
);

export default function App() {
  const classes = useStyles();
  const roomState = useRoomState();


  // Here we would like the height of the main container to be the height of the viewport.
  // On some mobile browsers, 'height: 100vh' sets the height equal to that of the screen,
  // not the viewport. This looks bad when the mobile browsers location bar is open.
  // We will dynamically set the height with 'window.innerHeight', which means that this
  // will look good on mobile browsers even after the location bar opens or closes.
  const height = useHeight();

  return (
    <Container style={{ height }}>
      <MenuBar />
      <Main>
        {roomState === 'disconnected' ? 
        <div className={classes.din}>
          <div> <LocalVideoPreview /> </div>
          <div className={classes.dinphones}> <DialInDetails /> </div>
          
        </div>: <Room />}
        <Controls />
      </Main>
      <ReconnectingNotification />
    </Container>
  );
}
